module.exports = __webpack_public_path__ + "img/list_Portrait_01.f7dc0778.jpeg";